import IBAN from 'iban'

export const validatorPositive = value => value >= 0
export const validatorStrictPositive = value => value > 0

export const validatorPassword = password => {
  /* eslint-disable no-useless-escape */
  const regExp = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%&*()]).{8,}/
  /* eslint-enable no-useless-escape */
  const validPassword = regExp.test(password)
  return validPassword
}

export const validatorCreditCard = creditnum => {
  /* eslint-disable no-useless-escape */
  const cRegExp = /^(?:3[47][0-9]{13})$/
  /* eslint-enable no-useless-escape */
  const validCreditCard = cRegExp.test(creditnum)
  return validCreditCard
}

export const validatorUrl = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }
  /* eslint-disable no-useless-escape */
  const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

export const validatorIban = val => IBAN.isValid(val)

export const validatorTel = val => true

export const validatorDecimalOrInt = val => {
  if (val === undefined || val === null || val.length === 0) {
    return true
  }

  /* eslint-disable no-useless-escape */
  const re = /^((\d+)((\.\d{1,4})?))$/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}

export const validatorPercentage = val => {
  /* eslint-disable no-useless-escape */
  const re = /(^100(\.0{1,2})?$)|(^([1-9]([0-9])?|0)(\.[0-9]{1,2})?$)/
  /* eslint-enable no-useless-escape */
  return re.test(val)
}
